// src/com/auto_plan_bind_group/AutoPlanBindGroupGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * AUTO_PLAN_BIND_GROUP Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-10-15 15:02:47 using DbdbTap.
 ************************************************ */

/*
Type definitions on server:


type StoreNode {
	setOrderNum: Int!
	storeId: String!
}

# Remove a key to be created
input InputAutoPlanBindGroupAdd {
	condiVehTypeId: String
	condiPtCnt: Int
	storeSetList: [StoreNode!]!
}

input InputAutoPlanBindGroupEdit {
	groupOrderNum: Int!
	condiVehTypeId: String
	condiPtCnt: Int
	storeSetList: [StoreNode]
}

input InputAutoPlanBindGroupRemove {
	groupOrderNum: Int!
}

*/

export const ADD_AUTO_PLAN_BIND_GROUP = gql`
mutation AddAutoPlanBindGroup($autoPlanBindGroup:InputAutoPlanBindGroupAdd!) {
	autoPlanBindGroupAdd(autoPlanBindGroup: $autoPlanBindGroup) {
		ok
		message
	}
}
`;

export const EDIT_AUTO_PLAN_BIND_GROUP = gql`
mutation EditAutoPlanBindGroup($autoPlanBindGroup:InputAutoPlanBindGroupEdit!) {
	autoPlanBindGroupEdit(autoPlanBindGroup: $autoPlanBindGroup) {
		ok
		message
	}
}
`;

export const REMOVE_AUTO_PLAN_BIND_GROUP = gql`
mutation RemoveAutoPlanBindGroup($autoPlanBindGroup:InputAutoPlanBindGroupRemove!) {
	autoPlanBindGroupRemove(autoPlanBindGroup: $autoPlanBindGroup) {
		ok
		message
	}
}
`;
